export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <path d="M14 44 L32 16 L50 44" stroke="#C5A059" strokeWidth="2.5" />
    <path d="M14 44 H50" stroke="#C5A059" strokeWidth="2.5" />
    <path d="M32 16 V44" stroke="#C5A059" strokeWidth="1" opacity="0.35" />
    <circle cx="14" cy="44" r="4" fill="#C5A059" />
    <circle cx="50" cy="44" r="4" fill="#C5A059" />
    <circle cx="32" cy="16" r="4" fill="#0A192F" />
    <circle cx="32" cy="44" r="2" fill="#C5A059" opacity="0.6" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <div className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <div className="leading-none">
      <div className={`font-heading font-semibold tracking-[0.14em] text-sm ${light ? "text-white" : "text-midnight"}`}>
        ROYAL DEALS <span className="text-gold">FZ-LLC</span>
      </div>
      <div className={`font-heading text-[9px] font-medium tracking-[0.3em] mt-1 ${light ? "text-white/50" : "text-midnight/45"}`}>
        ADVANCED COMPUTE
      </div>
    </div>
  </div>
);
